<template>
  <div
    v-if="membership && membership.status === 'active'"
    class="group-chat fill-main"
  >
    <h2>{{ membership.name }}</h2>
    <chat-room
      :room="room"
    />
  </div>
  <div v-else-if="membership">
    You aren't allowed in group chat
  </div>
  <div v-else>
    You aren't a member of this group
  </div>
</template>

<script>
import ChatRoom from '../../components/GGChatRoom.vue';

export default {
  name: 'GroupChat',
  components: {
    ChatRoom,
  },
  computed: {
    id() { return parseInt(this.$route.params.id, 10); },
    membership() { return this.userGroups.find(g => g.id === this.id); },
    room() {
      if (this.membership) {
        return `_group.${this.membership.id}`;
      }
      return null;
    },
  },
  mounted() {
    if (this.membership.status !== 'active') {
      this.$router.go(-1);
    }
  },
};
</script>
